var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGallery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 36,
    viewBox: "0 0 44 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 3.99A3.997 3.997 0 014.002 0h35.996A3.995 3.995 0 0144 3.99v28.02A3.997 3.997 0 0139.998 36H4.002A3.995 3.995 0 010 32.01V3.99zm4 28.02L39.998 32C40 32 40 3.99 40 3.99L4.002 4C3.999 4 4 32.01 4 32.01zm10.055-19.204c.494-.99 1.375-1.035 1.96-.112l3.398 5.359a2.019 2.019 0 002.77.622l1.979-1.23a2.157 2.157 0 012.867.571l4.528 6.353c.642.9.264 1.631-.839 1.631H9.483c-1.105 0-1.6-.806-1.108-1.793l5.68-11.401zM33 16a3 3 0 110-6 3 3 0 010 6z",
    fill: "#3848DA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGallery);
export default __webpack_public_path__ + "static/media/gallery.5e531a5f5f754398af38fad108646cc9.svg";
export { ForwardRef as ReactComponent };